import Skeleton from "@/components/Skeleton"
import ImageWebpComponent from "@/components/ImageWebpComponent"
import classNames from "classnames"
import { ImageModeration } from "@/components/shared/ImageInViewBase"

interface WorkflowImageProps {
  image?: ImageModeration
  imageLoaded: boolean
  setImageLoaded: (loaded: boolean) => void
  isShow?: boolean
  workflow: {
    name?: string
  }
}

const WorkflowImage = ({ image, imageLoaded, setImageLoaded, isShow, workflow }: WorkflowImageProps) => {
  return (
    <Skeleton className="group rounded-2xl h-full w-full flex items-center justify-center" isLoaded={imageLoaded}>
      <div className="h-full select-none block">
        <ImageWebpComponent
          src={image?.url}
          alt={workflow.name ?? ""}
          className={classNames("block object-contain w-full h-full", {
            "blur-2xl": !imageLoaded || isShow,
          })}
          onLoad={() => setImageLoaded(true)}
        />
      </div>
    </Skeleton>
  )
}

export default WorkflowImage
